import { useColorMode } from '@chakra-ui/react';

interface CornerHolderProps {
  className?: string;
}

const CornerHolder = ({ className }: CornerHolderProps) => {
  const { colorMode } = useColorMode();
  const isDarkMode = colorMode === 'dark';

  if (isDarkMode) {
    return (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="73"
        height="73"
        viewBox="0 0 73 73"
        fill="none"
        aria-label="corner holder"
        aria-hidden="true"
        className={className}
      >
        <g filter="url(#filter0_f_1503_30326)">
          <path
            d="M3.80005 68.8C12.336 68.8 20.7883 67.1188 28.6745 63.8522C36.5606 60.5857 43.7262 55.7978 49.762 49.762C55.7978 43.7262 60.5857 36.5606 63.8522 28.6745C67.1188 20.7883 68.8 12.336 68.8 3.80005L3.80005 3.80005L3.80005 68.8Z"
            fill="black"
            fillOpacity="0.73"
          />
        </g>
        <path
          d="M1.80005 68.8C10.5986 68.8 19.311 67.067 27.4398 63.7C35.5687 60.3329 42.9547 55.3977 49.1762 49.1762C55.3977 42.9547 60.3329 35.5686 63.7 27.4398C67.067 19.311 68.8 10.5986 68.8 1.80005L1.80005 1.80005L1.80005 68.8Z"
          fill="#0D0E12"
        />
        <defs>
          <filter
            id="filter0_f_1503_30326"
            x="4.88758e-05"
            y="4.88758e-05"
            width="72.6"
            height="72.6"
            filterUnits="userSpaceOnUse"
            colorInterpolationFilters="sRGB"
          >
            <feFlood floodOpacity="0" result="BackgroundImageFix" />
            <feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
            <feGaussianBlur stdDeviation="1.9" result="effect1_foregroundBlur_1503_30326" />
          </filter>
        </defs>
      </svg>
    );
  }
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="71"
      height="71"
      viewBox="0 0 71 71"
      fill="none"
      aria-label="corner holder"
      aria-hidden="true"
      className={className}
    >
      <g filter="url(#filter0_f_1485_29784)">
        <path
          d="M4 67C12.2733 67 20.4655 65.3705 28.1091 62.2044C35.7526 59.0384 42.6976 54.3978 48.5477 48.5477C54.3978 42.6976 59.0384 35.7526 62.2044 28.1091C65.3705 20.4655 67 12.2733 67 4L4.00001 4L4 67Z"
          fill="black"
          fillOpacity="0.1"
        />
      </g>
      <path
        d="M-2.92866e-06 67C8.79856 67 17.511 65.267 25.6398 61.8999C33.7686 58.5329 41.1546 53.5977 47.3762 47.3762C53.5977 41.1546 58.5329 33.7686 61.8999 25.6398C65.267 17.511 67 8.79856 67 0L0 0L-2.92866e-06 67Z"
        fill="white"
      />
      <defs>
        <filter
          id="filter0_f_1485_29784"
          x="0"
          y="0"
          width="71"
          height="71"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
          <feGaussianBlur stdDeviation="2" result="effect1_foregroundBlur_1485_29784" />
        </filter>
      </defs>
    </svg>
  );
};

export default CornerHolder;
